"use client";

import * as React from "react";
import { MapPin } from "lucide-react";
export default function DovePeschiamo() {
  return <section data-section-id="224995" id="our-location" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-2.5 md:px-6">
        <div className="relative w-full h-[500px] md:h-[700px] rounded-xl overflow-hidden bg-secondary/30 border border-border shadow-md">
          {}
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2798.244444444444!2d-122.70000000000002!3d45.46666666666667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54950b0000000001%3A0x0!2zODk0OCBTVyBCYXJidXIgQmx2ZCwgUG9ydGxhbmQsIE9SIDk3MjE5!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus" className="absolute inset-0 w-full h-full border-0" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Portland Wellness Spa Location">
            <p className="p-4 text-center">Your browser does not support iframes. Please visit us at 8948 SW Barbur Blvd, Portland, OR 97219.</p>
          </iframe>

          {}
          <div className="absolute bottom-6 left-6 right-6 md:left-8 md:bottom-8 md:right-auto max-w-sm bg-background/95 backdrop-blur-md p-6 rounded-lg border border-border shadow-lg z-10">
            <div className="flex items-start gap-4">
              <div className="p-2 bg-primary/10 rounded-md">
                <MapPin className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-default font-bold text-xl text-primary mb-1">Our Sanctuary</h3>
                <p className="text-muted-foreground font-sans leading-relaxed">
                  8948 SW Barbur Blvd<br />
                  Portland, OR 97219
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-6 flex items-center justify-center gap-2 text-sm text-muted-foreground font-sans">
          <MapPin className="w-4 h-4 text-chart-2" />
          <span>Visit us in the heart of Portland for your wellness journey.</span>
        </div>
      </div>
    </section>;
}